import * as React from 'react'
import { Button, Col, Container, Modal, Row } from 'react-bootstrap'
import { AiOutlineRight } from 'react-icons/ai'
import { Link } from 'gatsby'
import { StoreContext } from '../../../context/store-context'
import CartIcon from '../../../icons/cart'
import CrossIcon from '../../../icons/cross'
import {
  emptyStateHeading,
  emptyStateLink,
  grandTotal,
  labelColumn,
  summary,
  totals,
  wrap,
} from '../../../pages/cart/cart.module.scss'
import { formatPrice } from '../../../utils/format-price'
import { badge } from '../CartButton/cart-button.module.scss'
import { LineItem } from '../MiniLineItem/miniLineItem'
import bestSellingProduct from './best-selling.json'
import {
  active,
  checkoutBtn as addToCartStyle,
  cart,
  cartHeading,
} from './cart-slideout.module.scss'

export function CartSlideout({ showCart, setShowCart }) {
  const [showModal, setShowModal] = React.useState(false)
  const [url, setUrl] = React.useState('')

  const { checkout, loading, client } = React.useContext(StoreContext)
  const emptyCart = checkout.lineItems.length === 0

  React.useEffect(() => {
    const getCheckoutUrl = async () => {
      if (!client || !checkout.id) {
        return
      }
      const utms = JSON.parse(localStorage.getItem('r4u_utms')) || {
        utm_source: 'Unknown',
        utm_medium: 'Unknown',
        utm_campaign: 'Unknown',
        gclid: 'Unknown',
        fbclid: 'Unknown',
        _ga:
          ('; ' + document.cookie).split(`; _ga=`).pop().split(';')[0] ||
          'Unknown',
      }

      const input = {
        customAttributes: Object.keys(utms).map((item) => {
          return { key: item, value: utms[item] }
        }),
      }

      try {
        const updatedCheckout = await client.checkout.updateAttributes(
          checkout.id,
          input,
        )
        setUrl(updatedCheckout.webUrl.split('?')[0])
        // windowRef.location = updatedCheckout.webUrl
      } catch (e) {
        console.log(e)
        // setShowModal(true)
      }
    }

    const interval = setInterval(() => {
      getCheckoutUrl()
    }, 1000)

    return () => clearInterval(interval)
  }, [client, checkout.id])

  // const handleCheckout = async () => {
  //   const utms = JSON.parse(localStorage.getItem("r4u_utms")) || {
  //     utm_source: "Unknown",
  //     utm_medium: "Unknown",
  //     utm_campaign: "Unknown",
  //     gclid: "Unknown",
  //     fbclid: "Unknown",
  //     _ga:
  //       ("; " + document.cookie).split(`; _ga=`).pop().split(";")[0] ||
  //       "Unknown",
  //   }

  //   const input = {
  //     customAttributes: Object.keys(utms).map((item) => {
  //       return { key: item, value: utms[item] }
  //     }),
  //   }

  //   try {
  //     let windowRef = window.open()
  //     const updatedCheckout = await client.checkout.updateAttributes(
  //       checkout.id,
  //       input
  //     )
  //     windowRef.location = updatedCheckout.webUrl
  //   } catch (e) {
  //     setShowModal(true)
  //   }
  // }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleContinueModal = () => {
    setShowModal(false)
    window.open(checkout.webUrl)
  }

  const pricePerItem = checkout.lineItems.map((item) => {
    return item?.variant.priceV2.amount
      ? Number(item?.variant.priceV2.amount) * item.quantity
      : 0
  })

  const fakeDiscountTotal = pricePerItem.map((x) => x / 0.75)
  const fakeDiscountPercent = fakeDiscountTotal.map((x) => x * 0.25)
  const sumfakeDiscountPercent = fakeDiscountPercent.reduce(
    (partialSum, a) => partialSum + a,
    0,
  )
  const sumfakeDiscountTotal = fakeDiscountTotal.reduce(
    (partialSum, a) => partialSum + a,
    0,
  )

  const discount = checkout.lineItems.map((item) => {
    return item?.discountAllocations[0]?.allocatedAmount.amount
      ? Number(item?.discountAllocations[0]?.allocatedAmount.amount)
      : 0
  })
  const sumDiscount = discount.reduce((partialSum, a) => partialSum + a, 0)

  const items = checkout ? checkout.lineItems : []

  const quantity = items.reduce((total, item) => {
    return total + item.quantity
  }, 0)

  return (
    <aside className={`${showCart && active} ${cart} cartSlideoutWrapper`}>
      <Container>
        <Row className={cartHeading}>
          <Col className='position-relative'>
            <CartIcon />
            {quantity > 0 && (
              <div
                className={badge}
                style={{
                  right: 'unset',
                  left: '35px',
                  bottom: 'unset',
                  top: '0px',
                }}
              >
                {quantity}
              </div>
            )}
          </Col>
          <Col>
            <CrossIcon onClick={() => setShowCart(false)} />
          </Col>
        </Row>
        <Row>
          <div className={`${wrap} pt-3`}>
            {emptyCart ? (
              <div className=''>
                <h4 className={emptyStateHeading}>Your cart is empty</h4>
                <p>
                  Looks like you haven’t found anything yet. We understand that
                  sometimes it’s hard to choose — maybe this helps:
                </p>
                {bestSellingProduct.map((item) => (
                  <Link
                    key={item.id}
                    to={`/products/${item.variant.product.handle}`}
                  >
                    <LineItem item={item} emptyCart={true} />
                    <hr className='mt-3' />
                  </Link>
                ))}
                <Link to='/search?s=BEST_SELLING' className={emptyStateLink}>
                  View more trending products
                </Link>
              </div>
            ) : (
              <>
                {checkout.lineItems.map((item) => (
                  <React.Fragment key={item.id}>
                    <LineItem item={item} />
                    <hr className='mt-3' />
                  </React.Fragment>
                ))}
                <Row className={`mt-3 ${summary} fw-normal`}>
                  <Col className={labelColumn}>Total</Col>
                  <Col className={totals}>
                    {formatPrice(
                      checkout.subtotalPriceV2.currencyCode,
                      sumfakeDiscountTotal,
                    )}
                  </Col>
                </Row>
                <Row className={`mt-3 ${summary} fw-normal`}>
                  <Col className={labelColumn}>{/* Discount (25% Off) */}</Col>
                  <Col className={totals}>
                    -
                    {formatPrice(
                      checkout.subtotalPriceV2.currencyCode,
                      sumfakeDiscountPercent,
                    )}
                  </Col>
                </Row>
                {checkout.lineItems[0].discountAllocations[0] && (
                  <Row className={`mt-3 ${summary} fw-normal`}>
                    <Col className={labelColumn}>Additional Sale Discount</Col>
                    <Col className={totals}>
                      -
                      {formatPrice(
                        checkout.subtotalPriceV2.currencyCode,
                        sumDiscount,
                      )}
                    </Col>
                  </Row>
                )}
                <Row className={`mt-3 ${summary} fw-normal`}>
                  <Col className={labelColumn}>Subtotal</Col>
                  <Col className={totals}>
                    {formatPrice(
                      checkout.subtotalPriceV2.currencyCode,
                      checkout.subtotalPriceV2.amount,
                    )}
                  </Col>
                </Row>

                <Row className={`mt-3 ${summary} fw-normal`}>
                  <Col className={labelColumn}>Shipping</Col>
                  <Col className={totals}>Calculated at payment screen</Col>
                </Row>
                <Row className={`mt-3 ${grandTotal} fw-normal`}>
                  <Col className={labelColumn}>Total Price</Col>
                  <Col className={totals}>
                    {formatPrice(
                      checkout.totalPriceV2.currencyCode,
                      checkout.totalPriceV2.amount,
                    )}
                  </Col>
                </Row>
                <Row className='mt-3'>
                  <Link
                    className='block w-full'
                    to={url}
                    target='_blank'
                    // onClick={(e) => e.preventDefault()}
                  >
                    <Button
                      primary='true'
                      // onClick={handleCheckout}
                      disabled={loading}
                      className={`btn-buy justify-content-center align-items-center mw-100 ${addToCartStyle}`}
                      style={{ width: '100%' }}
                    >
                      Checkout
                      <span className='icon d-none d-lg-block'>
                        <AiOutlineRight />
                      </span>
                    </Button>
                  </Link>
                </Row>
              </>
            )}
          </div>
        </Row>
      </Container>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>Having Trouble Checking Out?</Modal.Body>
        <Modal.Footer>
          <Button
            primary='true'
            className='btn-buy py-2'
            onClick={handleContinueModal}
          >
            Click Here
          </Button>
        </Modal.Footer>
      </Modal>
    </aside>
  )
}
